			(function($) {
              
var areClipPathShapesSupported = function () {

	var base = 'clipPath',
		prefixes = [ 'webkit', 'moz', 'ms', 'o' ],
		properties = [ base ],
		testElement = document.createElement( 'testelement' ),
		attribute = 'polygon(50% 0%, 0% 100%, 100% 100%)';

	// Push the prefixed properties into the array of properties.
	for ( var i = 0, l = prefixes.length; i < l; i++ ) {
		var prefixedProperty = prefixes[i] + base.charAt( 0 ).toUpperCase() + base.slice( 1 ); // remember to capitalize!
		properties.push( prefixedProperty );
	}

	// Interate over the properties and see if they pass two tests.
	for ( var i = 0, l = properties.length; i < l; i++ ) {
		var property = properties[i];

		// First, they need to even support clip-path (IE <= 11 does not)...
		if ( testElement.style[property] === '' ) {

			// Second, we need to see what happens when we try to create a CSS shape...
			testElement.style[property] = attribute;
			if ( testElement.style[property] !== '' ) {
				return true;
			}
		}
	}

	return false;
};
              
				// VERTICAL ALIGN FUNCTION
				$.fn.verticalAlign = function () { /* VERTICAL ALIGN FUNCTION */
					return this
					.css("margin-top",($(this).parent().height() - $(this).height())/2 + 'px' )
				};

				// SEARCH ACTION
                $('a[href="#search"]').on('click', function(event) {
                  event.preventDefault();
                  $('#search').addClass('open');
                  $('#search > form > input[type="search"]').focus();
                });

                $('#search, #search .close, .megamenu, .megamenu .close').on('click keyup', function(event) {
                  if (event.target == this || event.target.className == 'close' || event.keyCode == 27) {
                    $(this).removeClass('open');
                  }
                });
                  
                // MEGAMENU ACTION
                $(".megamenuaction").on('click', function(event) {
                  event.preventDefault();
                  var addressValue = $(this).attr("href");
                  $(addressValue).addClass('open');
                });
              
                // WISHLIST POPUP
                $('.wishlist-modal').magnificPopup({
                  type:'inline',
                  removalDelay: 1000,
                  mainClass: 'mfp-fade',
                  midClick: true
                });

                // IFRAME POPUP FOR VIDEOS
                $('.open-popup-link').magnificPopup({
                  type:'iframe'
                });
              
                // SMOOTH ALL OTHER LINKS THAT AREN'T NAV
                $(function() {
                  $('a[href*=\\#]:not([href=\\#])').click(function() {
                    if(!$(this).hasClass('wishlist-modal')) {
                      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                        var target = $(this.hash);
                        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                        if (target.length) {
                          $('html,body').animate({
                            scrollTop: target.offset().top
                          }, 500);
                          return false;
                        }
                      }
                    }
                  });
                });

                // CRAZY MOVEMENT FOR PRODUCTS
              
              
              
              
              
              
              
                var myBoxes = $('[data-scroll-speed]');
                $(window).scroll(function(){
                  var scrollTop = $(window).scrollTop();
                  myBoxes.each(function(){
                    var $this = $(this);
                    var scrollspeed = parseInt($this.attr('data-scroll-speed')),
                        scrollstart = parseInt($this.attr('data-scroll-start')),
                        offset = scrollstart -  ( scrollTop / scrollspeed );
                    $this.css('transform', 'translateY(' + offset + 'px)');
                  });
                });
                $(window).load(function(){
                  $('[data-scroll-speed]').each(function(){
                    var viewportHeight = $(window).height(),
                        middleScreen = (viewportHeight - $(this).outerHeight()) / 2,
                        randNum = Math.floor(Math.random() * 8) + 3,
                        yOff = middleScreen/randNum,
                        elementOffset = $(this).offset().top,
                        yTranslate = -(yOff - (elementOffset / randNum));

                    $(this).attr('data-scroll-speed',randNum).attr('data-scroll-offset',elementOffset).attr('data-scroll-start',yTranslate).css('transform','translateY(' + yTranslate + 'px)');
                  });
                });
              
              
              
              
              
              
              
              

                // COLLECTION OF COLLCTIONS BEHAVIOR
                $('.collection-overlay .quickexplore').on('click',function(e){
                  e.preventDefault();
                  var coll_overlay = $(this).closest('.collection-overlay');
                  $('.collection-overlay.opened').removeClass('opened').animate({
                    left:0,
                    opacity:1
                  }, 1000, 'swing', function() {
                    console.log( "all done" );
                  });
                  $(this).closest('.collection-overlay').addClass('opened').animate({
                    left:'-100%',
                    opacity:0.25
                  }, 1000, 'swing', function() {
                    console.log( "all done" );
                  });
                });
                $('.closequickexplore').on('click',function(e){
                  e.preventDefault();
                  $('.collection-overlay.opened').removeClass('opened').animate({
                    left:0,
                    opacity:1
                  }, 1000, 'swing', function() {
                    console.log( "all done" );
                  });
                });

				$(function() { /* on document load */
                  
                  if ( areClipPathShapesSupported() ) {
                    $('body').addClass('supports-clippath');
                  }
				
				  // SET UP BSELECT
				  $("select").niceSelect();

				  // SLIDESHOWS
                  $('.galleryimages').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    fade: true,
                    asNavFor: '#ProductThumbs'
                  });
                  $('#ProductThumbs').slick({
                    infinite: false,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    asNavFor: '.galleryimages',
                    prevArrow: '<button type="button" class="slick-prev"></button>',
                    nextArrow: '<button type="button" class="slick-next"></button>',
                    responsive: [
                      {
                        breakpoint: 600,
                        settings: {
                          slidesToShow: 2,
                          slidesToScroll: 1
                        }
                      }
                    ]
                  });
                  
                  $('.quickview-slideshow').each(function (idx, item) {
                    $(this).slick({
                      infinite: true,
                      speed: 300,
                      slidesToShow: 5,
                      slidesToScroll: 1,
                      prevArrow: '<button type="button" class="slick-prev"></button>',
                      nextArrow: '<button type="button" class="slick-next"></button>',
                      responsive: [
                        {
                          breakpoint: 769,
                          settings: {
                            slidesToShow: 3
                          }
                        },
                        {
                          breakpoint: 426,
                          settings: {
                            slidesToShow: 1
                          }
                        }
                      ]
                    });
                  });
                  $('.quickview-slideshow').on('beforeChange', function(event, slick, currentSlide, nextSlide){
                    console.log(nextSlide);
                    $(this).find('li').removeClass('opacitytemp');
                    if(currentSlide == 0 && nextSlide != 1) {
                      $(this).find('li').addClass('opacitytemp');
                    }
                    if(currentSlide != 1 && nextSlide == 0) {
                      $(this).find('li').addClass('opacitytemp');
                    }
                  });
                  $('.quickview-slideshow').on('afterChange', function(slick, currentSlide){
                    $(this).find('li').removeClass('opacitytemp');
                  });

                  $('.quickview-slideshow2').each(function (idx, item) {
                    $(this).slick({
                      infinite: true,
                      speed: 300,
                      slidesToShow: 1,
                      prevArrow: '<button type="button" class="slick-prev"></button>',
                      nextArrow: '<button type="button" class="slick-next"></button>',
                      responsive: [
                        {
                          breakpoint: 769,
                          settings: {
                            slidesToShow: 2
                          }
                        },
                        {
                          breakpoint: 426,
                          settings: {
                            slidesToShow: 1
                          }
                        }
                      ]
                    });
                  });
                  
                  $('#art-gallery').slick({
                    infinite: true,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    prevArrow: '<button type="button" class="slick-prev"></button>',
                    nextArrow: '<button type="button" class="slick-next"></button>',
                    responsive: [
                      {
                        breakpoint: 769,
                        settings: {
                          slidesToShow: 2
                        }
                      },
                      {
                        breakpoint: 426,
                        settings: {
                          slidesToShow: 1
                        }
                      }
                    ]
                  });


                  function msieversion() {

                      var ua = window.navigator.userAgent;
                      var msie = ua.indexOf("MSIE ");

                      if (
                        msie > 0 
                        || 
                        !!navigator.userAgent.match(/Trident.*rv\:11\./)  // If Internet Explorer, return version number
                        ||
                        $(document).width() < 1024
                      )
                      { }
                      else  // If another browser, return 0
                      {
                        // PARALLAXING BG IMAGES
                        
                        //removed 8-12-20, jarallax is causing all sorts of spacing and background coverage issues
                        $('.jarallax').jarallax({
                          speed: 0.8
                        });
                        
                      }

                      return false;
                  }
                  msieversion();
                  
				  // ACTIVATE SAME HEIGHT FUNCTION
				  $('.sameheight').equalHeightColumns();
                  
                });
				
				$(window).load(function() { /* on window load */

				  // VERTICAL ALIGN
				  $('.vertalign').each(function() {
				    $( this ).verticalAlign();
				  });
					
                  // PRODUCRT ZOOM
                  $("#ProductPhoto").zoom();

                  // SET OFF THE PARALLAX
                  window.scrollBy(0,1);
                  
				});

				var jRes = jRespond([ /* responsive jquery functions */
					{
						label: 'handheld',
						enter: 0,
						exit: 767
					},{
						label: 'tablet',
						enter: 768,
						exit: 1023
					},{
						label: 'laptop',
						enter: 1024,
						exit: 1199
					},{
						label: 'desktop',
						enter: 1200,
						exit: 10000
					}
				]);
			
				jRes.addFunc([
					{
						breakpoint: ['desktop','laptop','tablet'],
						enter: function() {},
						exit: function() {}
					},{
						breakpoint: ['handheld'],
						enter: function() {},
						exit: function() {}
					},{
					}
				]);
				
			})(jQuery);